import Vue from 'vue'
import Router from 'vue-router' 
Vue.use(Router);



var $router = new Router({
  mode:'hash',  //使用history防止url中出现#
  routes: [
	{
	  path: '/show/:id',
	  component: function (){
	  		 return import ('@/pages/show')
	  },
	  meta : {
		  keepAlive : false
	  },
	  beforeEnter: (to, from, next) => {
			//console.log('page1 beforeEnter~');
			next();
	  }
	  
	},
    {
      path: '/home',
      component: function (){
      		 return import ('@/pages/home')
      },
      meta : {
      		  keepAlive : true
      },
      beforeEnter: (to, from, next) => {
      		//	console.log('home beforeEnter~');
      			next();
      }
    },
	{
	  path: '/detail/:id',
	  component: function (){
	  		 return import ('@/pages/detail')
	  },
	  meta : {
	  		  keepAlive : false
	  },
	  beforeEnter: (to, from, next) => {
	  		//	console.log('page3 beforeEnter~');
	  			next();
	  }
	},
     { path: '*', redirect: '/home' }
    

  ]
})


$router.beforeEach((to,from,next) => {
	//console.log('beforeEach~~~~~'); 
	 next();
})

$router.beforeResolve((to,from,next) => {
	console.log('beforeResolve~~~~~'); 
	 next();
})


$router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
})



export default $router;